import { render, staticRenderFns } from "./Labarugi.vue?vue&type=template&id=5266e9e0"
import script from "./Labarugi.vue?vue&type=script&lang=js"
export * from "./Labarugi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports